import React, { useRef, useState, useEffect } from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import loader from '../../../assets/img/loader.svg'
import { useMessagesContext } from '../../../_providers/Messages'
import Api from '../../../_helpers/Api'
import { trans } from '../../../_providers/Translation'

let timeout

function Messages(props) {
    // Get current user info for thread logic
    const auth = require('../../../_providers/Auth')
    const currentUserId = auth.id ? auth.id() : null
    const currentUserType = auth.type ? auth.type() : null

    const messages = useMessagesContext()

    const ref = useRef(null)

    const [state, setState] = useState({
        loading: true,
        list: [],
        page: 1,
        pages: 0,
        count: 0,
        hasMore: true,
        search: '',
        update: false,
        key: Math.random().toString(),
        initLoad: true
    })

    useEffect(() => {
        loadData()
    }, [state.update])

    useEffect(() => {
        if (!state.initLoad) {
            handleUpdate()
        }
    }, [messages.count, messages.lastMessage])

    const loadData = (page = 1) => {
        let url = 'messages/recent?page=' + page + '&name=' + state.search

        Api.get(url)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    list: [...prev.list, ...res.data.items],
                    pages: res.data.pages,
                    hasMore: res.data.has_more,
                    loading: false,
                    initLoad: false
                }))
            })
    }

    const handleSearch = e => {
        let val = e.target.value

        clearTimeout(timeout)

        timeout = setTimeout(() => {
            setState(prev => ({
                ...prev,
                search: val,
            }))

            handleUpdate()

        }, 500)
    }

    const handleUpdate = () => {
        setState(prev => ({
            ...prev,
            list: [],
            loading: true,
            update: new Date().getTime(),
            key: Math.random().toString()
        }))
    }

    // Patch: Always open the correct thread based on current user and recent item
    const handleOpenChat = (item) => {
        let subject = null
        if (item.reservation_id && !isNaN(item.reservation_id)) {
            // Reservation chat
            subject = {
                id: item.receiver_subject?.id,
                type: item.receiver_subject?.type,
                name: item.receiver_subject?.name,
                lastname: item.receiver_subject?.lastname,
                avatar: item.receiver_subject?.avatar,
                reservationId: item.reservation_id,
                tenant_id: item.tenant_id,
                sender_id: item.author_id // pass sender_id for context
            }
        } else {
            // Always use receiver_id as subject_id for all user-to-user chats
            subject = {
                id: item.receiver_id,
                type: item.receiver_subject?.type,
                name: item.receiver_subject?.name,
                lastname: item.receiver_subject?.lastname,
                avatar: item.receiver_subject?.avatar,
                tenant_id: item.receiver_tenant_id,
                sender_id: item.author_id // pass sender_id for context
            }
        }
        if (subject && subject.id && subject.type) {
            messages.openChat(subject)
        }
    }

    return (
        <div className={`show messages-module`}>
            <div className="head">
                {trans('headings.messages')}
            </div>
            <div className="body">
                <input
                    type="search"
                    name="search"
                    placeholder="Търсене..."
                    onChange={handleSearch}
                />
                <div className="scroll" ref={ref} key={state.key}>
                    {state.loading
                        ?
                        <img src={loader} alt="loading" />
                        :
                        state.list.length === 0
                            ?
                            <p className="no-data">{trans('messages.noMessages')}</p>
                            :
                            <InfiniteScroll
                                element="ul"
                                initialLoad={false}
                                pageStart={1}
                                loadMore={loadData}
                                hasMore={state.hasMore}
                                loader={<img key="loader" src={loader} alt="loading" />}
                                useWindow={false}
                                getScrollParent={() => ref.current}
                            >
                                {state.list.map((el, i) =>
                                    <li key={'msg-' + (el.id || i)} className={el.unread_count ? 'unread' : ''} onClick={() => handleOpenChat(el)}>
                                        <picture>
                                            {el.receiver_subject && el.receiver_subject.avatar && (
                                                <img src={el.receiver_subject.avatar} alt="avatar" />
                                            )}
                                        </picture>
                                        <div className="right">
                                            <time className="timer" data-date={el.created_at}>
                                                {el.published}
                                            </time>
                                            <h3>
                                                {el.receiver_subject && el.receiver_subject.name ? el.receiver_subject.name : ''} {el.receiver_subject && el.receiver_subject.lastname ? el.receiver_subject.lastname : ''}
                                                {/* Show indicator if this conversation is external */}
                                                {el.source === 'external' && (
                                                    <span style={{
                                                        background: '#3990eeff',
                                                        color: '#fff',
                                                        borderRadius: '6px',
                                                        padding: '2px 6px',
                                                        marginLeft: '2px',
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        display: 'inline-block',
                                                        marginTop: '2px'
                                                    }}>
                                                        {trans('labels.partner')}
                                                    </span>
                                                )}
                                            </h3>
                                            {el.reference_code
                                                ?
                                                <span style={{ display: 'block', fontSize: '10px', marginTop: '3px' }}>
                                                    <a className="btn" style={{ padding: '2px 7px', fontSize: '9px', background: el.reservation_color, color: el.reservation_text_color }}>
                                                        {trans('random.refNo')} {el.reference_code}
                                                    </a>
                                                </span>
                                                :
                                                ''}
                                            <p>
                                                {el.message && el.message.length > 20 ? el.message.substring(0, 20) + '...' : el.message}
                                            </p>
                                        </div>
                                    </li>
                                )}
                            </InfiniteScroll>
                    }
                </div>
            </div>
        </div>
    )
}

export default Messages